export enum CookieKeys {
  AccessToken = "accessToken",
  ReturnUrl = "returnUrl",
  RefreshToken = "refreshToken",
}
